export enum LayoutStyle {
    Default = "default",
    TwoColorsGreenAndWhite = "two-colors-background",
    OneGreen = "one-green-background",
    GreenCircleGradient = "home-background",
}